@if (warrantyCompensation !== null) {
  <p>{{warrantyCompensation.url}}</p>
}
